import { Component, OnInit } from '@angular/core';
import { EditAccountOwner } from '../../_models/editAccountOwner';
import { InvoiceMenu } from '../../_models/invoiceMenu';
import { Address } from '../../_models/address';
import { DataTableDirective } from 'angular-datatables';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import * as _ from "lodash";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { Product } from '../../_models/product';
import { AccessSecurity } from '../../_models/accessSecurity';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-my-account-list',
  templateUrl: './my-account-list.component.html',
  styleUrls: ['./my-account-list.component.css']
})
export class MyAccountListComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  totalCount = 0;
  preference: any[] = [];
  shippingMode: string;
  carrierMode: string;
  configLineIdSeq: any = [];
  numberOfBoxesM: any = [];
  carrierPreference: any = [];
  shippingModeError: string;
  shipPreferences: any;
  viewSeller: any;
  carrierModeError: string;
  printTypeCommonPageError: string;
  printTypeCommonPage: string;
  warehouseAssigned: any;
  tabClicked: string = "profile";
  statusTab: string = "active";
  sellerStatus: string = "ACTIVE";
  addressTab: string = "active";
  uploadImage: string;
  gstNumber: string;
  succesMessage: string;
  shipmentMode: string;
  id: null;
  notificationId: any;
  challanSettingsObj: any;
  profileLogo: any;
  addressList: any;
  warehouses: any;
  checkedList = [];
  checkedList2 = [];
  ordersMainMenu: any = [];
  invoicePreferenceOption: any;
  invoiceRequired: string = 'N';

  allOrdersMainMenu: InvoiceMenu[] = [
    { displayName: "Contact Information", tabClicked: "profile", additional: "N" },
    { displayName: "Address", tabClicked: "address", additional: "N" },
    { displayName: "Users", tabClicked: "manageUsers", additional: "N" },
    { displayName: "Shipping Preferences", tabClicked: "shippingPreference", additional: "N" },
    { displayName: "Password Management", tabClicked: "passwordManagement", additional: "N" },
    { displayName: "Bank Account Information", tabClicked: "bankAccountInfo", additional: "N" },
    { displayName: "Delete My Account", tabClicked: "deleteMyAccount", additional: "N" },
  ];

  bank: any = [{}];
  account: EditAccountOwner = {
    companyName: "",
    ownerName: "",
    mobile: 0,
    email: "",
    address1: "",
    imageUrl: "",
    address2: "",
    city: "",
    state: "",
    zip: 0,
    status: "",
    addressText: "",
    expiryDate: "",
    addressType: ""
  };


  baddress1: string;
  baddress2: string;
  bcity: string;
  bstate: string;
  statusText: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  statusText14: string;
  statusText15: string;
  statusText16: string;
  statusText17: string;
  statusText18: string;
  statusText19: string;
  statusText20: string;
  statusText21: string;
  imageUrl: string;

  emailTypeError: string;
  firstNameError: string;
  companyNameError: string;
  contactError: string;
  mobileError: string;
  emailError: string;
  ifscError: string;
  accountNameError: string;
  accountTypeError: string;
  accountNumberError: string;
  bankNameError: string;
  errorMessage: string;
  errorMessage2: string;
  specificType: string;
  duration: string;
  durationType: string;
  bzip: number;
  users: any;
  store: any = {
    syncType: ""
  };
  storeManage: any = {};
  shopifyProducts: any;
  wooProducts: any;
  shopifyOrders: any;
  wooOrders: any;
  magentoProducts: any;
  magentoOrders: any;
  ebayProducts: any;
  ebayOrders: any;
  flipkartOrders: any;
  shopcluesProducts: any;
  shopcluesOrders: any;
  notificationsList: any;
  productImage: string = "/assets/images/default-product.png";
  accountCommAddress: Address = {};
  accountBillingAddress: Address = {};
  secretKey: string;
  masterSelected: boolean = false;
  masterSelectedManageUser: boolean = false;
  description: string;
  config: string;
  days: string;
  activeProduct: Product;
  activeProducts: any = [];
  returnProducts: any = [];
  reasonList: any = [];
  accountTypeList: any = [];
  returnForDeleteProduct: any;
  returnForDelete: any;
  day: any = [];
  configError: string;
  activeProductError: any;
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  currentPwdError: string = '';
  newPwdError: string = '';
  confirmPwdError: string = '';
  invoicePreference: string = '';
  invoicePreferenceError: string = '';
  profileStep: number = 1;
  carriersList = [];
  carriersPreferencesList = [];
  userDrop2: any = 'profile';
  disableButton = true;
  orderPreferences: any = {};
  order: any = {};
  packageConfiguration = ['One SKU per Box', 'Multiple SKUs per Box'];
  selected = [];
  selectedMessage = this.selected.toString();

  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router, public accessSec: AccessSecurity) {
    this.order.productConfig = "SKU";
    this.g.page = "My Account";
    this.checkAccessToShowTabs();
    this.carriersList = [
      {label: 'Blue Dart', config: 'Blue Dart', name: 'BD'},
      {label: 'Shadowfax', config: 'Shadow Fax', name: 'SF'},
      {label: 'Whizzy', config: 'Whizzy', name: 'WZ'},
      {label: 'Borzo', config: 'Borzo', name: 'WF'},
      {label: 'Dotzot', config: 'Dotzot', name: 'DZ'},
      {label: 'Dunzo', config: 'DunZo', name: 'DN'},
      {label: 'Delhivery', config: 'Delhivery', name: 'DE'},
      {label: 'Gati', config: 'Gati', name: 'GT'},
      {label: 'Kerry', config: 'KerryExpress', name: 'KE'},
      {label: 'Ecom Express Pro', config: 'Ecom Express Pro', name: 'EX'},
      {label: 'Ecom Express EGS', config: 'Ecom Express EGS', name: 'EG'},
      {label: 'Xpressbees', config: 'Xpressbees', name: 'XB'}
    ];
    this.carriersPreferencesList = [
      { label: '1st Preference', config: '1st Preference' },
      { label: '2nd Preference', config: '2nd Preference' },
      { label: '3rd Preference', config: '3rd Preference' },
      { label: '4th Preference', config: '4th Preference' },
    ];
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      let index = this.ordersMainMenu.findIndex((d) => d.tabClicked === this.g.pageTab);
      if (index == -1) {
        this.g.pageTab = null;
        this.tabClicked = 'profile';
      }
    }
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      this.populateTabData(this.g.pageTab);
      for (let ol of this.ordersMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.switchPosition(ol);
        }
      }
    }
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
    }
    this.g.loaderDisplay = "display";
    this.api.getAccountOwner(this.user.accountOwnerId).subscribe((data: EditAccountOwner) => {
      this.g.loaderDisplay = "";
      this.account = data;
      if (data.email) {
        this.getAllCustomerInfosByEmailAndCode(data.email);
      }
      if (this.account.adddressList !== null) {
        for (let add of this.account.adddressList) {
          if (add.addressType === "COMMUNICATION") {
            this.accountCommAddress = _.cloneDeep(add);
          } else if (add.addressType === "BILLING") {
            this.accountBillingAddress = _.cloneDeep(add);
          }
        }
      }
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });

  }

  checkAccessToShowTabs() {
    if (this.user.role === 'ROLE_USER') {
      this.allOrdersMainMenu.forEach((s) => {
        if ((s.displayName === "Invoice Preferences") || (s.displayName === "Shipping Preferences" && !this.accessSec.shippingPreferences) || (s.displayName === "Label Preferences" && !this.accessSec.labelPreferences) || (s.displayName === "Return Settings" && !this.accessSec.returnPreferences) || (s.displayName === "Payment" && !this.accessSec.payment)) {
        } else {
          this.ordersMainMenu.push(s);
        }
      });
    } else {
      this.ordersMainMenu = this.allOrdersMainMenu;
    }
  }

  getAddressList(status) {
    this.g.loaderDisplay = "display";
    this.api.getAddressList(status).subscribe((data: any) => {
    this.g.loaderDisplay = "";
    this.addressList = data.getAddressesResponseList;
    },
    err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  openDeletePopup() {
    this.profileStep = 2;
  }

  profileMenu() {
    this.profileStep = 1;
  }

  getUsersByAccOwnerId(status) {
    this.g.loaderDisplay = "display";
    this.api.getUsersByAccOwnerId(status).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.users = data.getAccountOwnerUserResponseList;
      this.totalCount = data.count;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  addressReset() {
    this.checkedList2 = [];
    this.errorMessage2 = '';
    for (var i = 0; i < this.addressList.length; i++) {
      this.addressList[i].isSelected = false;
    }
  };

  editAddress(addressList) {
    let i = 0;
    let ohid;
    for (let a of addressList) {
      if (a.isSelected) {
        i = i + 1;
        ohid = a.addressId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/editAddress/' + ohid]);
    } else {
      this.errorMessage2 = "Can not edit multiple Addresses at once. Please select one at a time";
    }
  }

  reasonSettingsList() {
    this.g.loaderDisplay = "display";
    this.api.getValues("1", "ACCOUNT_OWNER", this.user.accountOwnerId, "REASON").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.reasonList = data.tripleSetConfigDTOS;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  accountType() {
    this.g.loaderDisplay = "display";
    this.api.getValues("1", "BANK_ACCOUNT_DETAILS", "ACCOUNT_TYPE", "ACCOUNT_TYPE").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.accountTypeList = data.tripleSetConfigDTOS;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  getShippingPreferences() {
    this.carrierPreference = [];
    this.g.loaderDisplay = "display";
    this.api.getShippingPreferences().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.shipPreferences = data.prefResponses;
      this.shipPreferences.forEach((s) => {
        let index = this.carriersList.findIndex((d) => d.config === s.carrierName);
        if (index > -1) {
          this.carrierPreference[index] = s.preference;
        }
      });
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  getSellers(sellerStatus) {
    this.g.loaderDisplay = "display";
    this.api.getAllSellersByStatus(sellerStatus).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.viewSeller = data;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  getOrder(notImp) {
  }

  checkedServices(selectedValue) {
    if (this.selected.indexOf(selectedValue) != -1) {
      return true
    }
  }

  changePackage(checked, service) {
    if (checked) {
      this.selected.push(service);
    }
    else {
      this.selected.splice(this.selected.indexOf(service), 1);
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.tab) {
        this.tabClicked = params.tab;
        this.router.navigate([], {
          queryParams: {
            tab: null,
          },
          queryParamsHandling: 'merge',
        });
      }
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
    this.g.pageTab = undefined;
  }

  getList() {
    this.g.loaderDisplay = "display";
    this.api.getNotificationSettingsList().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.notificationsList = data.notificationSettingsResponses;
      this.notificationsList.forEach((notification) => {
        notification.notificationTypes.forEach((n) => {
          if (n.notify === 'ON') {
            n.enabled = true;
          } else {
            n.enabled = false;
          }
        });
      });

    }, err => {
      this.g.loaderDisplay = "";
      console.log(err);
    });
  }

  getAllCustomerInfosByEmailAndCode(email) {
    this.g.loaderDisplay = "display";
    this.api.getAllCustomerInfosByEmailAndCode(email, 'COMPANY_LOGO', 1).subscribe((data: EditAccountOwner) => {
      this.profileLogo = data;
      this.g.loaderDisplay = "";
      if (this.profileLogo != null) {
        this.imageUrl = this.profileLogo.value;
      } else {
        this.imageUrl = this.productImage;
      }
    }, err => {
      this.g.loaderDisplay = "";
    });
  }

  populateTabData(triggered) {
    this.tabClicked = triggered;
    this.g.pageTab = triggered;
    if (this.tabClicked === 'warehouse') {
      this.getWarehouseAssignmentList();
    } else if (this.tabClicked === 'address') {
      this.getAddressList("ACTIVE");
    } else if (this.tabClicked === 'manageUsers') {
      this.getUsersByAccOwnerId("ACTIVE");
    } else if (this.tabClicked === 'notifications') {
      this.getList();
    } else if (this.tabClicked === 'invoicePreference') {
      this.getInvoicePreference();
    } else if (this.tabClicked === 'shippingPreference') {
      this.getShippingPreferences();
    } else if (this.tabClicked === 'manageSellers') {
      this.getSellers("ACTIVE");
    } else if (this.tabClicked === 'bankAccountInfo') {
      this.accountType();
      this.getBankDetails();
    } else if (this.tabClicked === 'orderPreference') {
      this.getOrderPreferenceValues();
    }
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.addressList.length; i++) {
      this.addressList[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList2 = [];
    for (var i = 0; i < this.addressList.length; i++) {
      if (this.addressList[i].isSelected) {
        this.checkedList2.push(this.addressList[i]['addressId']);
      }
    }

  }

  populateValues(triggered) {
    if (this.tabClicked == 'address') {
      this.addressTab = triggered;
    } else if (this.tabClicked == 'manageUsers') {
      this.statusTab = triggered;
    } else if (this.tabClicked == 'manageSellers') {
      this.sellerStatus = triggered;
    }
  }

  tabChange() {
    this.checkedList2 = [];
    this.errorMessage2 = "";
    this.g.loaderDisplay = "display";
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.ordersMainMenu[4].displayName) {
      this.ordersMainMenu[4].additional = 'Y';
    }
    var tmp = 5;
    for (let o of this.ordersMainMenu) {
      if (tmp < this.ordersMainMenu.length) {
        if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
          this.ordersMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  changeStatus(n) {
    this.g.loaderDisplay = "display";
    if (n.status == "ACTIVE") {
      n.status = "IN_ACTIVE";
    } else {
      n.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/changeUserStatus', {
      "id": n.id,
      "status": n.status,
      "organizationId": this.user.organizationId
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == "200") {
        this.users.splice();
        this.alertService.success('Manage Users', 'Status Updated Successfully');
      } else {
        if (n.status == "ACTIVE") {
          n.status = "IN_ACTIVE";
        } else {
          n.status = "ACTIVE";
        }
        this.alertService.error(data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });

    if (this.tabClicked != 'all') {
      let index = this.users.indexOf(n);
      this.users.splice(index, 1);
    }
  }

  changeSellerStatus(n) {
    this.g.loaderDisplay = "display";
    if (n.status == "ACTIVE") {
      n.status = "IN_ACTIVE";
    } else {
      n.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateSellerAccountStatus', {
      "id": n.sellerId,
      "status": n.status,
      "organizationId": this.user.organizationId,
      "accountOwnerId": this.user.accountOwnerId
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == "200") {
        this.alertService.success('Seller', 'Status Updated Successfully');
        this.viewSeller.splice();
      } else {
        if (n.status == "ACTIVE") {
          n.status = "IN_ACTIVE";
        } else {
          n.status = "ACTIVE";
        }
        this.alertService.error(data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });

    if (this.tabClicked != 'all') {
      let index = this.viewSeller.indexOf(n);
      this.viewSeller.splice(index, 1);
    }
  }

  validateEmail() {
    this.emailTypeError = "";
    if (this.account.email === '') {
      this.emailTypeError = 'Please enter email';
    }
    if (this.emailTypeError != "") {
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail',
      this.account.email
      ,
      {
        headers: header1
      }).subscribe(data => {
        if (data['code'] == 200) {

        } else {
          var errorMessage = "invalid email";
          if (data['code'] == 400) {
            errorMessage = data['message'];
          }
          this.emailTypeError = errorMessage;
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.emailTypeError = "Please enter Email.";
        }
      )
  }

  resetUsers() {
    this.checkedList = [];
    this.errorMessage = '';
    for (var i = 0; i < this.users.length; i++) {
      this.users[i].isSelected = false;
    }
  };

  resetCheckedList() {
    this.checkedList = [];
    this.errorMessage = '';
  };

  checkUncheckAllManageUser() {
    for (var i = 0; i < this.users.length; i++) {
      this.users[i].isSelected = this.masterSelectedManageUser;
    }
    this.getCheckedUserList();
  }

  selectUser(c) {
    if (!c.isSelected) {
      this.masterSelectedManageUser = false
    }
    this.getCheckedUserList();
  };

  editUsers(users) {
    let i = 0;
    let ohid;
    for (let c of users) {
      if (c.isSelected) {
        i = i + 1;
        ohid = c.id;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/editUser/' + ohid]);
    } else {
      this.errorMessage = "Can not edit multiple users at once. Please select one at a time";
    }
  };


  getCheckedUserList() {
    this.checkedList = [];
    for (var i = 0; i < this.users.length; i++) {
      if (this.users[i].isSelected) {
        this.checkedList.push(this.users[i]['id']);
      }
    }

  };

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.imageUrl = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.errorMessage = "";
    this.uploadImage = '';
    this.imageUrl = '';
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
        this.account.imageUrl = this.imageUrl;
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Registration Failed, please re-try.";
      });
  }

  challanSettings() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/createDeliveryChallanSettings', {
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": 1,
      "id": this.id,
      "logoUrl": this.imageUrl,
      "gstNumber": this.gstNumber
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Delivery Challan', 'Modified Successfully');
          this.router.navigate(['/admin/myAccountList']);

        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  typeEmailValidate() {
    this.emailTypeError = "";
    if (this.account.email == '' || this.account.email === null || this.account.email === undefined || this.account.email === 'undefined') {
      this.emailTypeError = 'Please enter Email';
    }
  }

  typeFirstName() {
    this.firstNameError = "";
    if (this.account.ownerName == '' || this.account.ownerName === null || this.account.ownerName === undefined || this.account.ownerName === 'undefined') {
      this.firstNameError = 'Please enter Name';
    }
  }

  submit() {
    this.g.loaderDisplay = "display";
    if (this.firstNameError == "" && this.emailTypeError == "") {

      this.firstNameError = "";
      this.emailTypeError = "";

      if (this.account.email == '' || this.account.email === null || this.account.email === undefined || this.account.email === 'undefined') {
        this.emailTypeError = 'Please enter Email';
      }

      if (this.account.ownerName == '' || this.account.ownerName === null || this.account.ownerName === undefined || this.account.ownerName === 'undefined') {
        this.firstNameError = 'Please enter Name';
      }
      if (this.emailTypeError != "" || this.firstNameError != "") {
        this.g.loaderDisplay = "";
        return false;
      }
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateAOBillingAddress', {
      "address1": this.accountBillingAddress.address1,
      "address2": this.accountBillingAddress.address2,
      "email": this.account.email,
      "name": this.account.ownerName,
      "addressType": "BILLING",
      "aoId": this.user.accountOwnerId,
      "city": this.accountBillingAddress.city,
      "organizationId": 1,
      "state": this.accountBillingAddress.state,
      "addressId": this.accountBillingAddress.addressId,
      "zip": this.accountBillingAddress.zip
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Accounting Billing', 'Submitted Successfully');

          this.router.navigate(['/admin/myAccountList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  typeCompanyName() {
    this.companyNameError = "";
    if (this.account.companyName == '' || this.account.companyName === null || this.account.companyName === undefined || this.account.companyName === 'undefined') {
      this.companyNameError = 'Please enter Company Name';
    }
  }

  typeContactName() {
    this.contactError = "";
    if (this.account.ownerName == '' || this.account.ownerName === null || this.account.ownerName === undefined || this.account.ownerName === 'undefined') {
      this.contactError = 'Please enter Contact Name';
    }
  }

  typeEmail() {
    this.emailError = "";
    if (this.account.email == '' || this.account.email === null || this.account.email === undefined || this.account.email === 'undefined') {
      this.emailError = 'Please enter Email';
    }
  }

  typePhoneNumber() {
    this.mobileError = "";
    if (this.account.mobile == 0 || this.account.mobile === null || this.account.mobile === undefined) {
      this.mobileError = 'Please enter Phone Number';
    }
  }

  typeAccountType() {
    this.accountTypeError = "";
    if (this.bank.accountType == 0 || this.bank.accountType === null || this.bank.accountType === undefined) {
      this.accountTypeError = 'Please enter the accountType';
    }
  }

  typeAccountName() {
    this.accountNameError = "";
    if (this.bank.accoutName === "" || this.bank.accountName === null || this.bank.accountName === undefined) {
      this.accountNameError = ' please enter the accountName'
    }
  }

  typeAccountNumber() {
    this.accountNumberError = "";
    if (this.bank.accountNumber === "" || this.bank.accountNumber === null || this.bank.accountNumber === undefined) {
      this.accountNumberError = "Please enter the account number"
    }
  }

  typeBankName() {
    this.bankNameError = "";
    if (this.bank.bankName === "" || this.bank.bankName === null || this.bank.bankName === undefined) {
      this.bankNameError = "Please enter the bank Name"
    }
  }

  typeIfscCode() {
    this.ifscError = "";
    if (this.bank.ifscCode === "" || this.bank.ifscCode === null || this.bank.ifscCode === undefined) {
      this.ifscError = " Please enter the Ifsc code"
    }

  }

  editAccountOwner() {
    this.g.loaderDisplay = "display";
    this.companyNameError = "";
    this.contactError = "";
    this.emailError = "";
    this.mobileError = "";

    if (this.account.companyName == '' || this.account.companyName === null || this.account.companyName === undefined || this.account.companyName === 'undefined') {
      this.companyNameError = 'Please enter Company Name';
    }
    if (this.account.ownerName == '' || this.account.ownerName === null || this.account.ownerName === undefined || this.account.ownerName === 'undefined') {
      this.contactError = 'Please enter Contact Name';
    }
    if (this.account.email == '' || this.account.email === null || this.account.email === undefined || this.account.email === 'undefined') {
      this.emailError = 'Please enter Email';
    }
    if (this.account.mobile == 0 || this.account.mobile === null || this.account.mobile === undefined) {
      this.mobileError = 'Please enter Phone Number';
    }
    if (this.companyNameError != "" || this.contactError != "" || this.emailError != "" || this.mobileError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateAccountOwner', {
      "companyName": this.account.companyName,
      "ownerName": this.account.ownerName,
      "mobile": this.account.mobile,
      "email": this.account.email,
      "website": this.account.website,
      "address1": this.accountCommAddress.address1,
      "address2": this.accountCommAddress.address2,
      "city": this.accountCommAddress.city,
      "state": this.accountCommAddress.state,
      "zip": this.accountCommAddress.zip,
      "addressId": this.accountCommAddress.addressId,
      "organizationId": 1,
      "id": this.user.accountOwnerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.submitLogo(data['imageUrl']);
          this.alertService.success('Customer', 'Edited Successfully');
          this.router.navigate(['/admin/myAccountList']);
        } else {
          this.alertService.error('Error', data['message']);

        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }




  manageBankAccount() {
    this.g.loaderDisplay = "display";
    this.accountTypeError = "";
    this.accountNameError = "";
    this.accountNumberError = "";
    this.bankNameError = "";
    this.ifscError = "";

    if (this.bank.accountType == '' || this.bank.accountType === null || this.bank.accountType === undefined || this.bank.accountType === 'undefined') {
      this.accountTypeError = 'Please enter Account Type Name';
    }
    if (this.bank.accountName == '' || this.bank.accountName === null || this.bank.accountName === undefined || this.bank.accountName === 'undefined') {
      this.accountNameError = 'Please enter Account Name';
    }
    if (this.bank.accountNumber == '' || this.bank.accountNumber === null || this.bank.accountNumber === undefined || this.bank.accountNumber === 'undefined') {
      this.accountNumberError = 'Please enter AccountNumber';
    }
    if (this.bank.bankName == 0 || this.bank.bankName === null || this.bank.bankName === undefined) {
      this.bankNameError = 'Please enter Bank Name';
    }
    if (this.bank.ifscCode == 0 || this.bank.ifscCode === null || this.bank.ifscCode === undefined) {
      this.ifscError = "Please enter ifsc code";
    }
    if (this.ifscError != "" || this.accountNameError != "" || this.accountTypeError != "" || this.accountNumberError != "" || this.bankNameError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/manageBankAccountDetails', {

      "accountName": this.bank.accountName,
      "accountNumber": this.bank.accountNumber,
      "accountOwnerId": this.user.accountOwnerId,
      "accountType": this.bank.accountType,
      "bankName": this.bank.bankName,
      "ifscCode": this.bank.ifscCode,

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {

          this.alertService.success('Bank details', 'Edited Successfully');

        } else {
          this.alertService.error('Error', data['message']);

        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  invoicePreferenceUpdate() {
    alert('Inside the invoicePreferenceUpdate method::' + this.invoicePreferenceOption);
    if (this.invoicePreferenceOption == true) {
      alert('Option Enabled');
    } else {
      alert('Option disabled');
    }

  }

  changeStatusAddress(c) {
    this.g.loaderDisplay = "display";
    if (c.status == "ACTIVE") {
      c.status = "IN_ACTIVE";
    } else {
      c.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateAddressStatus', {
      "addressId": c.addressId,
      "organizationId": this.user.organizationId,
      "aacountOwnerId": this.user.accountOwnerId,
      "status": c.status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.addressList.splice();
          this.alertService.success('Address', 'Status Updated Successfully');
        } else {
          if (c.status == "ACTIVE") {
            c.status = "IN_ACTIVE";
          } else {
            c.status = "ACTIVE";
          }
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
        let index = this.addressList.indexOf(c);
        this.addressList.splice(index, 1);
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  /*keyGenerate() {
   this.g.loaderDisplay = "display";
     var header1 = new HttpHeaders();
     header1 = header1.append('Content-Type', 'application/json');
     header1 = header1.append('Accept', 'application/json');
     header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));

     this.http.post(environment.apiUrl + 'api/generateAPIKey?accountOwnerId=' + this.user.accountOwnerId, {
         //"accountOwnerId": this.user.accountOwnerId
       },
       {headers: header1}).subscribe(data => {
       this.g.loaderDisplay = "";
         if (data['code'] == 200) {
                  this.alertService.success('Secrete Key','Generated successfully');

         this.secretKey = data['secretKey']
                   this.getAccess();
         }
         else{
              this.accessKeyErrorMessage = data['message'];
                           }
                       this.g.loaderDisplay = "";

       },
       (err: HttpErrorResponse) => {
       this.g.loaderDisplay = "";
       });
  }
               deleteApis() {
               this.g.loaderDisplay = "display";
                  var header1 = new HttpHeaders();
                  header1 = header1.append('Content-Type', 'application/json');
                  header1 = header1.append('Accept', 'application/json');
                  header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
                         this.http.delete(environment.apiUrl + 'api/deleteAccessKey/' + this.apiDelete.accountOwnerId,
                         {headers: header1}).subscribe(data => {
                         this.g.loaderDisplay = "";
                         this.alertService.success('Delete AccessKey','deleted successfully');
                         this.accessKey.apiKey='';
                         this.router.navigate(['/admin/myAccountList']);
                         if(data['code'] == 200) {

                         }
                         else{}
                         },
                         (err: HttpErrorResponse) => {
                         this.g.loaderDisplay = "";
                                 console.log(err);

                         }
                         );
               }

                      deleteApi(r) {
                             this.apiDelete = r;
                      }
 */
  submitLogo(imageUrl) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createCustomerAdditionalInfo', {
      "code": "COMPANY_LOGO",
      "email": this.account.email,
      "name": "Company Logo",
      "organizationId": 1,
      "accountOwnerId": this.user.accountOwnerId,
      "value": this.imageUrl
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {

          this.router.navigate(['/admin/myAccountList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  updateStatus(n, id) {

    if (n.enabled == true || n.settingsId) {
      this.notificationId = n.settingsId;
    } else {
      this.notificationId = n.id;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createCustNotificationSettings', {
      "accountOwnerId": this.user.accountOwnerId,
      "customerNotificationTypeId": n.customerNotificationTypeId,
      "id": this.notificationId,
      "notify": !n.enabled ? "OFF" : "ON",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        if (data && data['code'] == "200") {
          this.alertService.success('Notification', 'Status Updated Successfully');
          //this.getList();
          if (!n.settingsId) {
            n.settingsId = data['id'];
          }

        } else {
          this.alertService.error(data && data['message'] ? data['message'] : "Not getting any response");
          n.enabled = !n.enabled;
        }

        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  openUpdateStatus(n, id) {
    // alert("value ::" + n.displayPriority);
    if (n.enabled == true) {
      this.notificationId = n.settingsId;
    } else {
      this.notificationId = n.id;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createApiSettings', {
      "accountOwnerId": this.user.accountOwnerId,
      "customerNotificationTypeId": n.customerNotificationTypeId,
      "id": this.notificationId,
      "notify": n.enabled ? "OFF" : "ON",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success('Api', 'Status updated successfully');
          this.getList();
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  typeConfirmPwd() {
    this.confirmPwdError = '';
    if (!this.confirmPassword) {
      this.confirmPwdError = 'Please enter confirm password';
    } else if (this.confirmPassword !== this.newPassword) {
      this.confirmPwdError = 'Password does not match';
    }
  }

  typeNewPwd() {
    this.newPwdError = '';
    if (!this.newPassword) {
      this.newPwdError = 'Please enter new password';
    } else if (this.newPassword.length <= 5) {
      this.newPwdError = 'Password must be minimum 6 characters';
    }
  }

  typeCurrentPwd() {
    this.currentPwdError = '';
    if (!this.currentPassword) {
      this.currentPwdError = 'Please enter current password';
    }
  }

  submitChangePassword() {
    this.typeNewPwd();
    this.typeCurrentPwd();
    this.typeConfirmPwd();
    if (this.confirmPwdError != "" || this.newPwdError != "" || this.currentPwdError != "") {
      return false;
    }
    let request = {
      "currentPassword": this.currentPassword,
      "newPassword": this.newPassword
    };
    this.g.loaderDisplay = "display";
    this.api.changePassword(request).subscribe((data: any = []) => {
      if (data['code'] == 200) {
        this.g.loaderDisplay = "";
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.alertService.success('Password', 'Changed Successfully');
        //this.router.navigate(['/access/login']);
      } else {
        this.alertService.error('Error', data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";
      console.log(err);
      this.alertService.error('Error', 'Change Password Failed, please re-try.');
    });

  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }

  getWarehouseAssignmentList() {
    this.g.loaderDisplay = "display";
    this.api.getWHAssignmentList(this.user.accountOwnerId, "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.warehouses = data.getWHAssignmentsResponses;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  defaultWarehouse(index, warehouse) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/updateWarehouseAsDefault', {
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "warehouseId": this.warehouses[index].warehouseId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.warehouses.forEach((d) => {
            d.isDefault = 'No';
          });
          warehouse.isDefault = 'Yes';
          this.alertService.success('Warehouse', 'Set as Default');
          this.router.navigate(['/admin/myAccountList']);

        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  getInvoicePreference() {
    this.g.loaderDisplay = "display";
    this.api.getInvoicePreference().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoicePreference = data;
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  updateInvoicePreference() {
    this.invoicePreferenceError = "";

    if (!this.invoicePreference) {
      this.invoicePreferenceError = 'Please select invoice Preference';
      return false
    }

    this.g.loaderDisplay = "display";
    this.api.updateInvoicePreference('1', this.user.accountOwnerId, this.invoicePreference).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Invoice Preference', 'Updated Successfully');
      } else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }


  submitShippingLabel() {
    this.shippingModeError = "";
    this.carrierModeError = "";

    if (!this.shippingMode) {
      this.shippingModeError = 'Please Select Shipping Mode';
    }

    if (!this.carrierMode && this.shippingMode == 'ThirdParty') {
      this.carrierModeError = 'Please Select Carrier Mode';
    }

    if (this.shippingModeError != "" || this.carrierModeError != "") {
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createShippingAndLabelPreferences', {
      "accountOwnerId": this.user.accountOwnerId,
      "carrierMode": this.carrierMode,
      "organizationId": 1,
      "shippingMode": this.shippingMode
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shipping Label', 'Submitted  successfully');
          this.router.navigate(['/admin/myAccountList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  submitLabelPreference() {
    this.printTypeCommonPageError = "";

    if (!this.printTypeCommonPage) {
      this.printTypeCommonPageError = 'Please Select Shipping Mode';
    }

    if (this.printTypeCommonPageError != "") {
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/createShippingAndLabelPreferences', {
      "accountOwnerId": this.user.accountOwnerId,
      "preferredLabelFormat": this.printTypeCommonPage,
      "organizationId": 1,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Label Preference', 'Submitted  successfully');
          this.router.navigate(['/admin/myAccountList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  open() {
    this.preference = _.cloneDeep(this.carriersPreferencesList);
    for (let i = 0; i < this.carriersPreferencesList.length; i++) {
      let index = this.preference.findIndex((d) => d.label === this.carriersPreferencesList[i].label);
      if (index > -1) {
        this.carriersPreferencesList.splice(index, 1);
      }
    }
  }

  deleteShipPreference(s) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deletePreferences', {
      "id": s.id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == "200") {
          this.alertService.success('Preference', 'Updated Successfully');
        } else {
          this.alertService.error(data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  selectedPreferences(i, p, s) {
    this.g.loaderDisplay = "display";
    let query;
    for (let s of this.shipPreferences) {
      if (this.carrierPreference[i] === s.preference) {
        this.deleteShipPreference(s);
      }
    }
    query = {
      "accountOwnerId": this.user.accountOwnerId,
      "carrierName": p.config,
      "organizationId": this.user.organizationId,
      "preference": this.carrierPreference[i]
    };

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createCustomerShippingPreferences', query,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == "200") {
          this.alertService.success('Preference', 'Updated Successfully');
          this.populateTabData(this.g.pageTab);
          this.carrierPreference[i] = "";
        } else {
          this.alertService.error(data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  submitAll() {
    console.log("orderPreferences::" + this.orderPreferences)
    if (this.orderPreferences.invoicePreference == 'No' || this.orderPreferences.invoicePreference == null) {
      this.orderPreferences.invoicePreference = 'Yes';
    } else {
      this.orderPreferences.invoicePreference = 'No';
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/manageInvoicePreferences', {
      "accountOwnerId": this.user.accountOwnerId,
      "invoicePreference": this.orderPreferences.invoicePreference,
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  getBankDetails() {
    this.g.loaderDisplay = "display";
    this.api.getBankAccountDetails().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.bank = data;
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

  autoProcessOrder() {
    if (this.orderPreferences.autoOrderPreference == 'No' || this.orderPreferences.autoOrderPreference == null) {
      this.orderPreferences.autoOrderPreference = 'Yes';
    } else {
      this.orderPreferences.autoOrderPreference = 'No';

    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/manageAutoOrderPreference', {
      "accountOwnerId": this.user.accountOwnerId,
      "autoProcessOrder": this.orderPreferences.autoOrderPreference,
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  productConfigSelection() {
    this.selectedMessage = this.selected.toString();
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/managePackingConfiguration?accountOwnerId=' + this.user.accountOwnerId + '&organizationId=' + this.user.organizationId + '&packingConfiguration=' + this.selectedMessage, {},
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  getOrderPreferenceValues() {
    this.g.loaderDisplay = "display";
    this.api.getOrderPreferenceValues().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orderPreferences = data;
      this.selected = data.packageConfiguration;
      console.log("orderPreferences2" + this.orderPreferences)
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  confirmDelete() {
    this.g.loaderDisplay = "display";

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('jwt')
    });

    this.http.post(environment.apiUrl + 'api/deleteAccount', {}, { headers }).subscribe(
      (data: any) => {
        this.g.loaderDisplay = "";

        if (data.code == 200) {
          this.alertService.success('Account', 'Deleted Successfully');
        } else {
          this.alertService.error('Error', data.message || 'Something went wrong');
        }
      },
      (error: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', error.message || 'Server error');
      }
    );
  }


}

